import { useParams } from 'react-router-dom';
import { ConfigurableDashboard } from '@/features/analytics/components/Dashboard/ConfigurableDashboard';

export default function ConfigurableDashboardPage() {
  const { dashboardId } = useParams<{ dashboardId?: string }>();

  return <ConfigurableDashboard dashboardId={dashboardId} />;
}
